import { entity } from "simpler-state";

export const currentUser = entity(null);
export const setCurrentUser = (user) => currentUser.set(user);
